var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Section',{staticClass:"section-empty-entity",attrs:{"limiter":""}},[_c('Empty',[_c('span',{staticClass:"section-empty-entity__message"},[_vm._v("\n      "+_vm._s(_vm.message)+"\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }